import React from 'react';
import { Button, Spin } from '@douyinfe/semi-ui';
import { IconCopy } from '@douyinfe/semi-icons';
import { timestamp2string, isMobile } from '../helpers/utils';

const UNLIMITED = 100000000;

function fmt(value) {
  if (value === UNLIMITED) return '无限';
  if (value === '未知' || value === undefined || value === null) return '未知';
  return Number(value).toFixed(2);
}

// 令牌信息卡：总额 / 已用 / 剩余 / 有效期 + 用量进度条
const TokenInfoCard = ({ data, loading, onCopy }) => {
  const { balance, usage, accessdate, tokenValid } = data;
  const unlimited = balance === UNLIMITED;
  const remain = typeof balance === 'number' && typeof usage === 'number' ? balance - usage : null;
  const usedRatio =
    !unlimited && typeof balance === 'number' && balance > 0 && typeof usage === 'number'
      ? Math.min(Math.max(usage / balance, 0), 1)
      : null;

  const meterClass = usedRatio == null ? '' : usedRatio >= 0.9 ? 'danger' : usedRatio >= 0.7 ? 'warn' : '';

  return (
    <div className="panel fade-up fade-up-1">
      <div className="panel-head">
        <h3 className="panel-title">
          <span className="panel-title-dot" />
          令牌信息
        </h3>
        <Button
          icon={<IconCopy />}
          theme="borderless"
          type="primary"
          size="small"
          onClick={onCopy}
          disabled={!tokenValid}
        >
          {isMobile() ? '复制' : '复制令牌信息'}
        </Button>
      </div>
      <Spin spinning={loading}>
        <div className="token-info-grid">
          <div className="token-info-item">
            <div className="label">令牌总额</div>
            <div className="value">{fmt(balance)}</div>
          </div>
          <div className="token-info-item">
            <div className="label">已用额度</div>
            <div className="value">{unlimited ? '不计算' : fmt(usage)}</div>
          </div>
          <div className="token-info-item">
            <div className="label">剩余额度</div>
            <div className="value" style={remain != null && !unlimited && remain <= 0 ? { color: 'var(--critical)' } : undefined}>
              {unlimited ? '无限制' : remain != null ? remain.toFixed(2) : '未知'}
            </div>
          </div>
          <div className="token-info-item">
            <div className="label">有效期至</div>
            <div className="value">
              {accessdate === 0 ? '永不过期' : accessdate === '未知' ? '未知' : timestamp2string(accessdate)}
            </div>
          </div>
        </div>
        {usedRatio != null && (
          <div className="meter">
            <div className="meter-track">
              <div
                className={`meter-fill ${meterClass}`}
                style={{ width: `${(usedRatio * 100).toFixed(1)}%` }}
              />
            </div>
            <div className="meter-caption">
              <span>已使用 {(usedRatio * 100).toFixed(1)}%</span>
              <span>剩余 {(100 - usedRatio * 100).toFixed(1)}%</span>
            </div>
          </div>
        )}
      </Spin>
    </div>
  );
};

export default TokenInfoCard;
